module.exports = __webpack_public_path__ + "img/2.3d8b02f1.png";